import { useParams } from "react-router-dom";
import TermsAndConditions from "./TermsAndCondition";
import About from "./About";
import HelpCenter from "./HelpCenter";
import PrivacyPolicy from "./PrivacyPolicy";

export default function SettingsInnerPage() {
  const { type } = useParams();

  switch (type) {
    case "terms-and-conditions":
      return <TermsAndConditions />;
        case "privacy-policy":
      return <PrivacyPolicy />;
    case "about-us":
      return <About />;
    case "help-center":
      return <HelpCenter />;
  }
}
